import React from 'react';
import PropTypes from 'prop-types';
import useLocale from '@/hooks/useLocale';
import {
  ProtectionCardRoot,
  ProtectionCardBody,
  ProtectionCardShield,
  ProtectionCardTextBlock,
  ProtectionCardTitle,
  ProtectionCardDescription,
  ProtectionCardActions,
  ProtectionCardMonarx,
  ProtectionCardButtonLink,
} from '../ProtectionCardCompound';

const PendingInvoiceVariant = ({
  testId,
  onPendingInvoiceClick,
}) => {
  const { gatorProtect } = useLocale();
  const summary = gatorProtect && gatorProtect.summary;
  const block = summary && summary.protectionCard && summary.protectionCard.pendingInvoice;

  if (!block) {
    return null;
  }

  const actionsTestId = `${testId}__actions`;

  const handlePendingInvoiceClick = (e) => {
    e.preventDefault();
    if (onPendingInvoiceClick) {
      onPendingInvoiceClick();
    }
    return null;
  };

  return (
    <ProtectionCardRoot testId={testId}>
      <ProtectionCardBody>
        <ProtectionCardShield title={block.title} />
        <ProtectionCardTextBlock>
          <ProtectionCardTitle>{block.title}</ProtectionCardTitle>
          <ProtectionCardDescription html={block.description} />
          <ProtectionCardActions actionsTestId={actionsTestId}>
            <ProtectionCardButtonLink
              onClick={handlePendingInvoiceClick}
              testId={`${testId}__action-goToInvoices`}
            >
              {block.goToInvoices}
            </ProtectionCardButtonLink>
          </ProtectionCardActions>
        </ProtectionCardTextBlock>
      </ProtectionCardBody>
      <ProtectionCardMonarx title={block.title} />
    </ProtectionCardRoot>
  );
};

PendingInvoiceVariant.propTypes = {
  testId: PropTypes.string,
  onPendingInvoiceClick: PropTypes.func,
};

PendingInvoiceVariant.defaultProps = {
  testId: 'pending-invoice-variant',
  onPendingInvoiceClick: undefined,
};

export default PendingInvoiceVariant;
